export class AppenateCreateUserModel {
  type: string; // ['Full', 'Premium', 'Standard', 'Lite']
  firstName: string;//
  lastName: string;
  email: string;
  password: string;//(string, optional)
  externalId: string;//(string, optional)
  timeZone: string;//(string, optional)
  country: string;//(string, optional)
  websiteRole: string; // = ['ReadOnly', 'User', 'Admin', 'EnterpriseAdmin', 'VendorAdmin', 'SuperAdmin']
  folders: string[];//Array[string], optional
  groups: string[];//Array[string], optional
  doNotEmail: boolean = true; //boolean, optional
  colorCode: string;//(string, optional) Assign this user a unique color code. This will be used in various parts of the platform where users are identified by their color.
  useNames: boolean = false;//(boolean, optional) Use Names instead of GUID identifier for any Groups and Folders values
  useExternalIds: boolean = false; //(boolean, optional) Use External ID instead of GUID identifier for any Groups and Folders values
  companyId: number;//0,
  integrationKey: string;
}

export class AppenateDeleteUserModel{
  companyId: number;
  integrationKey: string;
  id: string; 
}

